import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import productsData from "../../public/data/products.json";

const REDIRECT_MAP: { [key: string]: string } = {
  "/welgrow": "/our-products/intron-welgrow",
  "/rapigrow": "/our-products/rapigrow",
  "/leadership": "/about-us/leadership",
  "/ammox": "/our-products/ammox",
  "/dynagro": "/our-products/dynagro",
  "/rumiferm": "/our-products/rumiferm",
  "/sanguard": "/our-products/sanguard",
  "/intramin-p": "/our-products/intramin-p",
  "/hepatostim": "/our-products/hepatostim",
  "/project/rapigrow": "/our-products/rapigrow",
  "/downloads": "/",
  "/tag/factory/feed": "/",
  "/careers": "/career",
  "/project/check": "/our-products/check",
  "/siltron-p": "/our-products/siltron-p",
  "/see-bio": "/our-products/see-bio",
  "/lactomax-gold": "/our-products/lactomax-gold-fs-me-ws",
  "/toxoff": "/our-products/toxoff",
  "/reboot-p": "/our-products/reboot-p",
  "/intramin-olp": "/our-products/intramin-ol-p",
  "/project/lactomax-gold-fs-me-ws": "/our-products/lactomax-gold-fs-me-ws",
  "/project/siltron": "/our-products/siltron",
};

export default function RedirectHandler() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const rawPathname = location.pathname;
    const searchParams = new URLSearchParams(location.search);

    // Enforce preferred non-www domain canonical redirection if visited via www
    if (window.location.hostname.startsWith("www.")) {
      const newHostname = window.location.hostname.substring(4);
      window.location.replace(`https://${newHostname}${location.pathname}${location.search}`);
      return;
    }

    // 1. Lowercase pathname and trim trailing slash
    let cleanPath = rawPathname.toLowerCase().trim();
    if (cleanPath !== "/" && cleanPath.endsWith("/")) {
      cleanPath = cleanPath.slice(0, -1);
    }

    // 2. Redirect index.php or index.html to /our-products
    if (cleanPath.startsWith("/index.php") || cleanPath.startsWith("/index.html")) {
      cleanPath = "/our-products";
    }

    // 3. Check static redirects map
    if (REDIRECT_MAP[cleanPath]) {
      cleanPath = REDIRECT_MAP[cleanPath];
    }

    // 4. Handle ?product=... parameter
    if (searchParams.has("product")) {
      const productParam = searchParams.get("product") || "";
      // clean product param to match nameId or name (decode URI first and strip symbols)
      const decodedProduct = decodeURIComponent(productParam).replace(/[®™]/g, "").trim().toLowerCase();
      // find product nameId in products.json
      const foundProduct = productsData.products.find((p: any) => {
        const nameClean = p.name.replace(/[®™]/g, "").trim().toLowerCase();
        const nameIdClean = p.nameId.toLowerCase();
        return nameClean === decodedProduct || nameIdClean === decodedProduct;
      });

      if (foundProduct) {
        cleanPath = `/our-products/${foundProduct.nameId}`;
      } else {
        // fall back to /our-products if not found
        cleanPath = "/our-products";
      }
      // We will clear search params for products
      searchParams.delete("product");
    }

    // 5. Query parameter cleanup (strip tracking parameters or unnecessary params like cat, lang, zarsrc)
    const keysToRemove = ["cat", "lang", "zarsrc"];
    keysToRemove.forEach(key => searchParams.delete(key));

    const finalSearch = searchParams.toString();
    const finalSearchStr = finalSearch ? `?${finalSearch}` : "";

    // 6. Navigate if the path or query parameters have changed
    const currentFullStr = rawPathname + location.search;
    const targetFullStr = cleanPath + finalSearchStr;

    if (currentFullStr.toLowerCase() !== targetFullStr.toLowerCase()) {
      navigate(targetFullStr, { replace: true });
    }
  }, [location, navigate]);

  return null;
}
